import React from 'react';

/** ActionBadge 色调：对齐主站 mobileBrandTagStyle 的 color-mix 公式。 */
export const getActionBadgeColors = (): Pick<
    React.CSSProperties,
    'backgroundColor' | 'color' | 'border'
> => ({
    backgroundColor: 'color-mix(in srgb, var(--brand-primary) 20%, transparent)',
    color: 'color-mix(in srgb, var(--brand-primary) 62%, var(--brand-on-primary))',
    border: '0.5px solid color-mix(in srgb, var(--brand-primary) 20%, transparent)',
});

interface ActionBadgeProps {
    label: string;
    fontSize?: string | number;
    padding?: string;
    borderRadius?: string;
    style?: React.CSSProperties;
}

const ActionBadge: React.FC<ActionBadgeProps> = ({
    label,
    fontSize = 'var(--font-size-sm)',
    padding = 'var(--space-xs) var(--space-10)',
    borderRadius = 'var(--radius-lg)',
    style,
}) => (
    <span
        style={{
            display: 'inline-flex',
            alignItems: 'center',
            fontSize,
            padding,
            borderRadius,
            whiteSpace: 'nowrap',
            ...getActionBadgeColors(),
            ...style,
        }}
    >
        {label}
    </span>
);

export default ActionBadge;
